import { IPivotStyles } from "@fluentui/react";

export const pivotStyles: IPivotStyles = {
  root: {
    display: "flex",
    gap: "10px",
    margin: 20,
  },
  link: {
    padding: "6px 16px",
    height: "32px",
    lineHeight: "20px",
    borderRadius: "8px",
    backgroundColor: "#d0e7f7", // Default light blue background
    fontWeight: "bold",
    color: "#0078D4",
    transition: "all 0.3s",
    textDecoration: "none", // Remove underline
    selectors: {
      ":hover": {
        backgroundColor: "#d0e7f7", // Keeps hover color as default
      },
    },
  },
  linkIsSelected: {
    backgroundColor: "#0078D4", // Darker blue for selected tab
    color: "white",
    textDecoration: "none", // Ensure underline is removed
  },
  linkContent: undefined,
  text: undefined,
  count: undefined,
  icon: undefined,
  linkInMenu: undefined,
  overflowMenuButton: undefined,
};
